import { render, staticRenderFns } from "./myRecord.vue?vue&type=template&id=1dbccc0f&scoped=true&"
import script from "./myRecord.vue?vue&type=script&lang=js&"
export * from "./myRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbccc0f",
  null
  
)

export default component.exports